import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { TReducerState } from '../../../app.config';
import { PageViewAndEditModeSwitchManager } from './page-view-and-edit-mode-switch-manager.class';

@Injectable({
  providedIn: 'root',
})
export class PageViewAndEditModeSwitchManagerResolver implements Resolve<PageViewAndEditModeSwitchManager> {
  private readonly globalStore = inject(Store<TReducerState>);

  public resolve(): PageViewAndEditModeSwitchManager {
    return new PageViewAndEditModeSwitchManager(this.globalStore);
  }
}
